export default "__VITE_ASSET__BkvK4NG___"